import React, { useState } from "react";
import "./ConsultForm.css";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PhoneInput } from "react-international-phone";

const ConsultForm = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    FName: "",
    LastName: "",
    Email: "",
    Company: "",
    Sales: "",
    Message: "",
    Number: "",
    Location: "",
  });

  const resetForm = () => {
    setFormData({
      FName: "",
      LastName: "",
      Email: "",
      Company: "",
      Sales: "",
      Message: "",
      Number: "",
      Location: "",
    });
  };

  const handlePhoneChange = (phone) => {
    setFormData((prev) => ({
      ...prev,
      Number: phone || "", // Ensure phone is a string
    }));
  };
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [responseMessage, setResponseMessage] = useState(null);

  const validateForm = () => {
    const errors = [];
    
    // Required field validation
    if (!formData.FName.trim()) errors.push("First Name is required");
    if (!formData.LastName.trim()) errors.push("Last Name is required");
    if (!formData.Email.trim()) errors.push("Email is required");
    if (!formData.Company.trim()) errors.push("Company is required");
    if (!formData.Message.trim()) errors.push("Message is required");
    if (!formData.Number.trim()) errors.push("Phone Number is required");

    // Email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.Email && !emailRegex.test(formData.Email)) {
        errors.push("Please Enter A Valid Email Address");
    }

    // Phone number validation (basic check for minimum length)
    if (formData.Number && formData.Number.length < 10) {
        errors.push("Please Enter A Valid Phone Number");
    }

    return errors;
};

const handleSubmit = async (e) => {
  e.preventDefault();
  
  // Validate form before submission
  const validationErrors = validateForm();
  if (validationErrors.length > 0) {
      // Show only the first validation error instead of multiple toasts
      toast.error(validationErrors[0]);
      return;
  }
  

  setLoading(true);

  try {
      const response = await fetch(
          "https://blueberry-travel.com/api/APIUser/SubmitEnquiryBBT",
          {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
          }
      );

      if (response.ok) {
          await response.json();
          toast.success("Enquiry Submitted. Our Team Will Contact You Shortly.");
          resetForm();
      } else {
          toast.error("Failed To Submit The Form. Please Try Again Later.");
      }
  } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("An Error Occurred While Submitting The Form.");
  } finally {
      setLoading(false);
  }
};

  return (
    <>
      <div className="consult-form">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 d-flex justify-content-center align-items-center">
              <h1 className="headings consult">
                <span>
                  Seeking Positive Change to Your Travel Journey{" "}
                  <span style={{ fontWeight: "bold" }}>? </span>{" "}
                </span>
                Connect with Our Experts Today
                <span style={{ fontWeight: "bold", color: "black" }}>! </span>
              </h1>
            </div>

            <div className="col-lg-6">
              <form className="form-container consultform-container" onSubmit={handleSubmit}>
                <div className="consult-form-row">
                  <div className="form-field">
                    <input
                      type="text"
                      name="FName"
                    
                      value={formData.FName}
                      onChange={(e) =>
                        setFormData({ ...formData, FName: e.target.value })
                      }
                      required
                    />
                    <label htmlFor="firstName">
                      First Name<span>*</span>
                    </label>
                  </div>
                  <div className="form-field">
                    <input
                      type="text"
                      name="LastName"
                      
                      value={formData.LastName}
                      onChange={(e) =>
                        setFormData({ ...formData, LastName: e.target.value })
                      }
                      required
                    />
                    <label htmlFor="lastName">
                      Last Name<span>*</span>
                    </label>
                  </div>
                </div>
                <div className="consult-form-row">
                  <div className="form-field">
                    <PhoneInput
                      country={"gb"}
                      value={formData.Number}
                      onChange={handlePhoneChange}
                      inputClassName="form-control"
                      containerClass="phone-input-container"
                      className="consult-phone-container"
                      inputProps={{
                        name: "Number",
                        required: true,
                        placeholder: "Phone Number",
                      }}
                      enableSearch={true}
                      preferredCountries={["gb", "us", "in"]}
                      required
                    />
                    <label htmlFor="mobileNumber" className="label2">
                      Mobile Number<span>*</span>
                    </label>
                  </div>

                  <div className="form-field">
                    <input
                      type="text"
                      name="Email"
                     
                      value={formData.Email}
                      onChange={(e) =>
                        setFormData({ ...formData, Email: e.target.value })
                      }
                      required
                    />
                    <label htmlFor="email" className="label3">
                      Work E-mail Address<span>*</span>
                    </label>
                  </div>
                </div>
                <div className="consult-form-row full-width">
                  <div className="form-field">
                    <input
                      type="text"
                      name="Company"
                     
                      value={formData.Company}
                      onChange={(e) =>
                        setFormData({ ...formData, Company: e.target.value })
                      }
                      required
                    />
                    <label htmlFor="company">
                      Company<span>*</span>
                    </label>
                  </div>
                </div>
                <div className="consult-form-row full-width">
                  <div className="form-field">
                    <textarea
                      name="Message"
                      rows="5"
                      value={formData.Message}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          Message: e.target.value,
                        })
                      }
                      required
                    ></textarea>
                    <label htmlFor="company" className="label4">
                      How can we help?<span>*</span>
                    </label>
                  </div>
                </div>
                <div className="terms-container d-flex justify-content-start align-items-start consult-form-row">
                  <input
                    type="checkbox"
                    id="terms"
                    className="checkbox-input"
                    required
                  />
                  <p className="text-dark">
                    Agree to{" "}
                    <Link to="/terms-and-conditions" className="text-decoration-none">
                      <span>T&C</span>
                    </Link>{" "}
                    of Blueberry Travels.
                  </p>
                </div>
                <div className="carouselCaption consult-enquir-btn">
                  {/* <button className="btn fs4 fw-bold bg-transparent text-black text-uppercase leeter">
                    Enquire Now
                  </button> */}
                  <button className="btn fs4 fw-bold bg-transparent text-black text-uppercase leeter" type="submit" disabled={loading} >
                    {loading ? 'Loading...' : 'ENQUIRE NOW'}
                  </button>
                </div>
              </form>
              <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999 }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConsultForm;
